<template>
  <div class="heroes-pick-status">
    <div v-if="picker" class="heroes-pick-status__picker">
      {{ actionWord }} игрок:
      <span class="heroes-pick-status__nickname ellipsis">
        {{ picker.nickname }}
      </span>
    </div>

    <Timer
      v-if="duration !== null"
      :duration="duration"
      class="heroes-pick-status__timer"
      ref="timer"
    />
    <span v-else>??:??</span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Timer from "@/components/ui/timer/Timer";
import { ActionWords, PicksStatus } from "./types";

export default {
  name: "HeroesPickStatus",

  components: {
    Timer
  },

  data: () => ({
    duration: null,
    totalDuration: 0
  }),

  computed: {
    ...mapGetters("tournaments", ["picker", "match", "pickInfo"]),
    actionWord() {
      return ActionWords[this.pickInfo.action].action;
    }
  },

  watch: {
    "match.id": {
      immediate: true,
      handler: "getTimer"
    }
  },

  methods: {
    getTimer() {
      this.$socket.emit("match_timer", this.match.id);
    }
  },

  sockets: {
    match_timer({ match_id, time, interval }) {
      if (this.match.id !== match_id) return;
      this.duration = Math.floor(time / 1000);
      const newTotal = Math.floor(interval / 1000);
      const t = this.totalDuration;
      this.totalDuration = newTotal;
      //restart timer manually coz duration prop will not change
      if (newTotal === t) {
        this.$refs.timer.restart();
      }
    },
    pick_ban_hero({ match_id, current, next }) {
      if (this.match.id !== match_id) return;

      // totalDuration of first stage is higher, need to update it for next stages
      if (current.order === 1) {
        this.getTimer();
      } else if (next.status === PicksStatus.Inprogress) {
        this.duration = this.totalDuration;
        this.$refs.timer.restart();
      }
    },
    reset_pick_ban({ match_id }) {
      if (this.match.id !== +match_id) return;
      this.getTimer();
    }
  }
};
</script>

<style lang="scss">
.heroes-pick-status {
  font-weight: bold;
  font-size: 24px;
  line-height: 33px;
  text-align: center;
  margin-bottom: 15px;

  &__picker {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__nickname {
    color: #e72f31;
    display: inline-block;
    margin-left: 5px;
    max-width: 200px;
  }

  &__timer {
    margin-top: 10px;
  }
}
</style>
